// Helper functions for working with the generated API client

import type { components } from '../types/api.generated';

export type ApiResponse = components['schemas']['ApiResponse'];

// Helper to handle API responses
export function handleApiResponse<T>(response: {
  data?: ApiResponse;
  error?: { error?: string };
}): T {
  if (response.error) {
    throw new Error(response.error.error || 'API request failed');
  }
  
  if (!response.data) {
    throw new Error('No data received');
  }
  
  if (!response.data.success) {
    throw new Error(response.data.error || 'Request failed');
  }
  
  return response.data.data as T;
}

// Helper for endpoints that return arrays
export function handleApiArrayResponse<T>(response: {
  data?: ApiResponse;
  error?: { error?: string };
}): T[] {
  if (response.error) {
    throw new Error(response.error.error || 'API request failed');
  }
  
  if (!response.data) {
    throw new Error('No data received');
  }
  
  if (!response.data.success) {
    throw new Error(response.data.error || 'Request failed');
  }
  
  return (response.data.data || []) as T[];
}

// Helper for endpoints with no response body
export function handleApiVoidResponse(response: {
  data?: unknown;
  error?: { error?: string };
}): void {
  if (response.error) {
    throw new Error(response.error.error || 'API request failed');
  }
}